import React from "react";
import { FeaturesContainer } from "./styles";
import {
	Bolt,
	Share,
	Favorite,
	Notifications,
	Collections,
	Translate,
	ColorLens,
	Event,
	TableChart,
	Dashboard,
	MeetingRoom
} from "@mui/icons-material";
import { Container } from "@mui/material";
import Reveal from "../../Components/Reveal";
import PageIntro from "../../Components/PageIntro";
import PageConversion from "../../Components/PageConversion";

const Features = () => {
	const _features = [
		{
			title: "Fast Creation",
			description: "Create, customize, and submit your invitation for review — we’ll have it live within 24 hours.",
			icon: <Bolt />
		},
		{
			title: "Share",
			description:
				"Share your invitation your way — via direct link, WhatsApp, Messenger, or QR code — making it simple for every guest to access and enjoy.",
			icon: <Share />
		},
		{
			title: "Save The Date",
			description:
				"Allow guests to save your event directly to their calendar in one tap, ensuring they never miss your special day.",
			icon: <Event />
		},
		{
			title: "Real-Time Notifications",
			description:
				"Stay instantly connected, whether you’re on iOS, Android, or Desktop, our push notifications keep everyone in the loop at the perfect moment.",
			icon: <Notifications />
		},
		{
			title: "RSVP",
			description: "Get instant responses and manage confirmations with zero stress.",
			icon: <Favorite />
		},
		{
			title: "Export RSVP to Excel",
			description: "Download all your guest RSVP responses as an Excel file, ready to review, share, or print anytime.",
			icon: <TableChart />
		},
		{
			title: "Invitation Dashboard",
			description: "Track opens, RSVPs, and guest responses at a glance with real-time stats for your invitation.",
			icon: <Dashboard />
		},
		{
			title: "Bilingual Support",
			description:
				"Deliver your invitation in English and Arabic with a smooth, fully localized experience that feels natural for every guest.",
			icon: <Translate />
		},
		{
			title: "Gallery",
			description: "Bring your event to life with uploading photos & videos.",
			icon: <Collections />
		},
		{
			title: "Multiple Color Themes",
			description:
				"Each template comes with four beautifully crafted color themes, allowing you to choose the style that best matches your taste and event.",
			icon: <ColorLens />
		},
		{
			title: "Multiple Entrance Themes",
			description: "Welcome your guests with a beautiful entrance animation to reveal your invitation.",
			icon: <MeetingRoom />
		},
		{
			title: "Guest Album",
			description:
				"Every moment, captured and shared by everyone — upload photos and videos to relive every memory together.",
			icon: <Collections />
		}
	];
	const variantFor = (i: number) => (i === 0 || i === 6 || i === 10 ? "deep" : i === 3 || i === 8 ? "blush" : "");

	return (
		<FeaturesContainer>
			<Container>
				<PageIntro title={"Features"}>
					A complete set of elegant features, tailored to match your vision — from stunning invitation designs to
						effortless guest management and interactive experiences your guests will love.
				</PageIntro>
				<div className={"grid"}>
					{_features.map((item, i) => (
						<div key={item.title} className={"cell"}>
							<Reveal delay={(i % 3) * 90}>
								<article className={`feature ${variantFor(i)}`}>
									<div className={"icon-wrap"}>{item.icon}</div>
									<h3>{item.title}</h3>
									<p>{item.description}</p>
								</article>
							</Reveal>
						</div>
					))}
				</div>
			</Container>
			<PageConversion />
		</FeaturesContainer>
	);
};

export default Features;
